import { render } from "./CommonAuthorTwo.vue?vue&type=template&id=10211606"
import script from "./CommonAuthorTwo.vue?vue&type=script&lang=js"
export * from "./CommonAuthorTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__